import React from 'react';
import styled from '@grebban/style-system-react';
import Button from 'components/Button';

export interface HeaderContactBlockProps {
    email: string;
    phone: string;
    /** @TODO find retailer – hidden until link/action is defined */
    findRetailerLabel?: string;
}

const CONTACT_TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/15_120_510_-1'] as const;

const ContactBlockWrapper = styled('div')`
    margin-top: 24px;
    padding-top: 16px;
    color: var(--ui-primary-aa);
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const ContactButton = styled(Button)`
    justify-content: flex-start;
`;

/** Email/phone open mailto/tel in new context; overlay is intentionally left open. */
export const HeaderContactBlock = ({ email, phone }: HeaderContactBlockProps) => (
    <ContactBlockWrapper>
        {email ? (
            <ContactButton theme="textButton" url={`mailto:${email}`} typography={CONTACT_TYPOGRAPHY}>
                {email}
            </ContactButton>
        ) : null}
        {phone ? (
            <ContactButton theme="textButton" url={`tel:${phone.trim()}`} typography={CONTACT_TYPOGRAPHY}>
                {phone}
            </ContactButton>
        ) : null}
        {/* @TODO find retailer – add link/action and show when ready */}
    </ContactBlockWrapper>
);
